import { Book, Bug, HelpCircle, MessageCircle, Newspaper } from "lucide-react"; // Added Newspaper
import { Link } from "react-router-dom";

export const Help = () => {
  return (
    <div className="p-4 sm:p-8 max-w-4xl mx-auto">
      <div className="flex items-center gap-3 mb-8">
        <HelpCircle className="w-8 h-8 text-zinc-200" />
        <h1 className="text-2xl sm:text-3xl font-bold text-zinc-200">Help Center</h1>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
        <div className="bg-zinc-800/50 backdrop-blur rounded-xl shadow-lg border border-zinc-700/50 flex flex-col justify-between">
          <div className="flex items-center gap-3 mb-4 p-6">
            <Book className="w-6 h-6 text-yellow-500" />
            <h2 className="text-xl font-bold text-zinc-200">Documentation</h2>
          </div>
          <p className="px-6 text-zinc-400 mb-4">
            Find detailed guides and documentation about using our platform. From getting
            started to advanced features.
          </p>
          <div className="px-6 pb-6">
            <Link
              to="/docs"
              className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-700/50 hover:bg-zinc-600/50 text-zinc-200 rounded-lg transition font-medium"
            >
              View Documentation
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </Link>
          </div>
        </div>

        <div className="bg-zinc-800/50 backdrop-blur rounded-xl shadow-lg border border-zinc-700/50 flex flex-col justify-between">
          <div className="flex items-center gap-3 mb-4 p-6">
            <MessageCircle className="w-6 h-6 text-yellow-500" />
            <h2 className="text-xl font-bold text-zinc-200">Contact Support</h2>
          </div>
          <p className="px-6 text-zinc-400 mb-4">
            Having trouble? Check out our troubleshooting guide or get in touch with our
            support team.
          </p>
          <div className="px-6 pb-6">
            <Link
              to="/docs/troubleshooting"
              className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-700/50 hover:bg-zinc-600/50 text-zinc-200 rounded-lg transition font-medium"
            >
              View Troubleshooting Guide
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </Link>
          </div>
        </div>

        {/* New Section for Blog Link */}
        <div className="bg-zinc-800/50 backdrop-blur rounded-xl shadow-lg border border-zinc-700/50 flex flex-col justify-between">
          <div className="flex items-center gap-3 mb-4 p-6">
            <Newspaper className="w-6 h-6 text-yellow-500" /> {/* Using Newspaper icon */}
            <h2 className="text-xl font-bold text-zinc-200">Explore Our Blog</h2>
          </div>
          <p className="px-6 text-zinc-400 mb-4">
            For in-depth articles, tutorials, and insights into music, haptics, and Pulse Player features, visit our blog.
          </p>
          <div className="px-6 pb-6">
            <Link
              to="/blog"
              className="inline-flex items-center gap-2 px-4 py-2 bg-zinc-700/50 hover:bg-zinc-600/50 text-zinc-200 rounded-lg transition font-medium"
            >
              Go to Blog
              <svg
                className="w-4 h-4"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth={2}
                  d="M9 5l7 7-7 7"
                />
              </svg>
            </Link>
          </div>
        </div>

        <div className="bg-zinc-800/50 backdrop-blur rounded-xl shadow-lg border border-zinc-700/50 md:col-span-2"> {/* Adjust col-span if layout needs it, or make blog full width on a new row */}
          <div className="flex items-center gap-3 mb-4 p-6">
            <Bug className="w-6 h-6 text-yellow-500" />
            <h2 className="text-xl font-bold text-zinc-200">Report an Issue</h2>
          </div>
          <form className="px-6 pb-6 space-y-4">
            <div>
              <label className="block text-sm font-medium mb-2 text-zinc-200">Issue Type</label>
              <select className="w-full px-4 py-2 bg-zinc-700/50 text-zinc-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 border border-zinc-600/50">
                <option>Technical Problem</option>
                <option>Account Issue</option>
                <option>Playback Problem</option>
                <option>Other</option>
              </select>
            </div>
            <div>
              <label className="block text-sm font-medium mb-2 text-zinc-200">Description</label>
              <textarea
                className="w-full px-4 py-2 bg-zinc-700/50 text-zinc-200 rounded-lg focus:outline-none focus:ring-2 focus:ring-yellow-500 h-32 resize-none border border-zinc-600/50"
                placeholder="Describe your issue..."
              />
            </div>
            <button
              type="submit"
              className="w-full px-4 py-2 bg-yellow-500 hover:bg-yellow-400 text-zinc-900 rounded-lg transition font-medium"
            >
              Submit Report
            </button>
          </form>
        </div>
      </div>
    </div>
  );
};
